import { render, staticRenderFns } from "./UserConsulta.vue?vue&type=template&id=256e01de&"
import script from "./UserConsulta.vue?vue&type=script&lang=js&"
export * from "./UserConsulta.vue?vue&type=script&lang=js&"
import style0 from "./UserConsulta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports